import React from 'react'
import { Col } from 'react-bootstrap'
import Sticky from 'react-stickynode'
import DashboardSingleTemplateRightContainerInformationContent from './information-content'
import DashboardSingleTemplateRightContainerInputRow from './input-row-container'
import DashboardSingleTemplateRightContainerDetailsTable from './table'
import './style.scss'
import { UpperRow } from '../../../library/upper-row'

const Index = () => {
    return(
        <Col md={5} className="dashboard-single-template-right-container">
            <Sticky enabled={true} top={100}>
                <Col className="inner-dashboard-single-template-right-container">
                    <UpperRow title="Detaljer"/>
                    <DashboardSingleTemplateRightContainerInformationContent/>
                    <DashboardSingleTemplateRightContainerInputRow/>
                    <DashboardSingleTemplateRightContainerDetailsTable/>
                </Col>
            </Sticky>
        </Col>
    )
}

export default Index